const styles = theme => ({
    root: {
        padding: theme.spacing(1)
    }
});
export default styles;